import React, { useState } from 'react';
import { useInjuryTokenEligibility } from '../../../hooks/useInjuryTokenStatus';
import { UtInjurySheet } from './UtInjurySheet';
import { withinInjuryClaimWindow } from './sheetMaths';

interface Props {
  playerId: string | null;
  gameId: string;
  matchNumber?: number | string;
  gameDate: string;
  onClaimed?: () => void;
  className?: string;
}

/**
 * "Picked up an injury?" link for a completed game. Renders nothing unless the
 * viewer can claim (selected for it, no claim yet, no active injury: see
 * check_injury_token_eligibility) and the game is inside the claim window.
 */
export const InjuryClaimLink: React.FC<Props> = ({ playerId, gameId, matchNumber, gameDate, onClaimed, className }) => {
  const inWindow = withinInjuryClaimWindow(gameDate);
  const { eligibility, recheckEligibility } = useInjuryTokenEligibility(inWindow ? playerId ?? undefined : undefined, inWindow ? gameId : undefined);
  const [open, setOpen] = useState(false);

  if (!playerId || !eligibility?.eligible) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={className ?? 'text-left text-[13px] font-semibold text-[#f0a35a] hover:text-ut-ink'}
      >
        Picked up an injury in #{matchNumber}? Claim an injury token →
      </button>
      <UtInjurySheet
        open={open}
        onClose={() => setOpen(false)}
        playerId={playerId}
        gameId={gameId}
        matchNumber={matchNumber}
        eligibility={eligibility}
        onClaimed={() => {
          void recheckEligibility();
          onClaimed?.();
        }}
      />
    </>
  );
};
